import { useEffect, useState } from 'react';

type Args = {
  filterParams: URLSearchParams;
  fetchFunction: () => Promise<void>;
};

type IUseClearableFilters = (props: Args) => {
  filterKey: number;
  setIsClearFilter: React.Dispatch<React.SetStateAction<boolean>>;
};

export const useClearableFilters: IUseClearableFilters = ({ filterParams, fetchFunction }) => {
  const filterParamsAreEmpty = (params: URLSearchParams): boolean => {
    for (const [, value] of params.entries()) {
      if (value) return false;
    }
    return true;
  };

  const [isClearFilter, setIsClearFilter] = useState<boolean>(false);
  const [filterKey, setFilterKey] = useState<number>(0);

  useEffect(() => {
    if (filterParamsAreEmpty(filterParams) && isClearFilter) {
      setFilterKey(prevKey => prevKey + 1);
      fetchFunction();
      setIsClearFilter(false);
    }
  }, [filterParams, isClearFilter]);

  return {
    setIsClearFilter,
    filterKey,
  };
};
